import React, { useId } from "react";
import cn from "classnames";

import { getSafeErrorText } from "../../../helpers/safeRender";
import styles from "./input.module.css";

const Input = ({
  autoComplete,
  inputMode,
  error,
  className,
  classNameError,
  classNameValid,
  classNameInvalid,
  classNameWrap,
  disabled,
  readOnly,
  id,
  isInvalid,
  name,
  maxLength,
  onChange,
  onKeyDown,
  onBlur,
  label,
  labelClass,
  placeholder,
  required,
  type = "text",
  value,
  icon,
  isAutoFocus,
  onClick,
  inputRef,
  ariaLabel,
  ariaLabelledBy
}) => {
  const generatedId = useId();
  // The label's for and the error's aria-describedby both need an id; callers that pass none get a generated one.
  const inputId = id || `input-${generatedId}`;

  const handleClick = () => {
    if (onClick) {
      onClick();
    }
  };

  return (
    <div className={classNameWrap}>
      {label && (
        <label className={cn(styles.label, labelClass)} htmlFor={inputId}>
          {label} {required && <span className={styles.asterisk}>*</span>}
        </label>
      )}
      <input
        autoComplete={autoComplete}
        inputMode={inputMode}
        className={cn(styles.input, className, { [styles.invalid]: isInvalid }, isInvalid ? classNameInvalid : classNameValid)}
        disabled={disabled}
        readOnly={readOnly}
        id={inputId}
        name={name}
        maxLength={maxLength}
        value={value}
        onBlur={onBlur}
        onChange={onChange}
        onKeyDown={onKeyDown}
        placeholder={placeholder}
        type={type}
        aria-invalid={Boolean(isInvalid)}
        aria-label={ariaLabel}
        aria-labelledby={ariaLabelledBy}
        aria-describedby={isInvalid ? `${inputId}-error` : undefined}
        /* eslint-disable-next-line jsx-a11y/no-autofocus */
        autoFocus={isAutoFocus}
        ref={inputRef}
        onClick={handleClick}
      />
      {icon}
      {isInvalid && (
        <div id={`${inputId}-error`} className={cn(styles.error, classNameError)} role="alert">
          {getSafeErrorText(error)}
        </div>
      )}
    </div>
  );
};

export default Input;
